import { useState, useEffect, DragEvent, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FileCheck,
  Download,
  Eye,
  Trash2,
  Upload,
  RefreshCcw,
  BriefcaseMedical,
  FileUser,
  CheckSquare,
} from "lucide-react";
import { toast } from "react-toastify";
import { useGetData } from "../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../interfaces/EvaluadoInterface";

import EvaluadoInfo from "../../../../components/EvaludoInfo";
import FileDropZone from "../../../../components/FileDropZone";
import usePdfPresencial from "../../../../hooks/usePdfPresencial";
import ConfirmarModal from "../../../../components/ConfirmarModal";

export const DocumentosListaPresencialScreen = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { uploadPDF, deletePDF, handleFile, fetchFilesData, handleMergePdfs } =
    usePdfPresencial();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileKeyToConfirm, setFileKeyToConfirm] = useState("");
  const [fileToConfirm, setFileToConfirm] = useState<any>(null);
  const [descriptionToConfirm, setDescriptionToConfirm] = useState<string>("");

  const [files, setFiles] = useState<{ [key: string]: File | string }>({
    file1: "Sin archivo seleccionado",
    file2: "Sin archivo seleccionado",
    file3: "Sin archivo seleccionado",
    file4: "Sin archivo seleccionado",
    file5: "Sin archivo seleccionado",
    file6: "Sin archivo seleccionado",
    file7: "Sin archivo seleccionado",
    file8: "Sin archivo seleccionado",
    file9: "Sin archivo seleccionado",
    file10: "Sin archivo seleccionado",
    file11: "Sin archivo seleccionado",
    file12: "Sin archivo seleccionado",
    file13: "Sin archivo seleccionado",
    file14: "Sin archivo seleccionado",
    file15: "Sin archivo seleccionado",
    file16: "Sin archivo seleccionado",
    file17: "Sin archivo seleccionado",
    file18: "Sin archivo seleccionado",
    file19: "Sin archivo seleccionado",
    file20: "Sin archivo seleccionado",
    file21: "Sin archivo seleccionado",
    file22: "Sin archivo seleccionado",
    file23: "Sin archivo seleccionado",
    file24: "Sin archivo seleccionado",
    file25: "Sin archivo seleccionado",
    file26: "Sin archivo seleccionado",
    file27: "Sin archivo seleccionado",
    file28: "Sin archivo seleccionado",
    file29: "Sin archivo seleccionado",
    file30: "Sin archivo seleccionado",
    file31: "Sin archivo seleccionado",
    file32: "Sin archivo seleccionado",
    file33: "Sin archivo seleccionado",
    file34: "Sin archivo seleccionado",
    file35: "Sin archivo seleccionado",
  });

  const [successFiles, setSuccessFiles] = useState<{ [key: string]: boolean }>({
    file1: false,
    file2: false,
    file3: false,
    file4: false,
    file5: false,
    file6: false,
    file7: false,
    file8: false,
    file9: false,
    file10: false,
    file11: false,
    file12: false,
    file13: false,
    file14: false,
    file15: false,
    file16: false,
    file17: false,
    file18: false,
    file19: false,
    file20: false,
    file21: false,
    file22: false,
    file23: false,
    file24: false,
    file25: false,
    file26: false,
    file27: false,
    file28: false,
    file29: false,
    file30: false,
    file31: false,
    file32: false,
    file33: false,
    file34: false,
    file35: false,
  });

  // Actualizar el estado en localStorage para que ModulosListaPresnecialScreen pueda accederlo
  useEffect(() => {
    // Guardar el estado de cada archivo en localStorage
    if (evaluadosList_id) {
      Object.entries(files).forEach(([key, value]) => {
        // Solo guardamos si no es un objeto File (ya que no podemos guardar objetos complejos en localStorage)
        if (typeof value === 'string') {
          localStorage.setItem(`documentos_evaluado_${evaluadosList_id}_${key}`, value);
        }
      });
    }
  }, [files, evaluadosList_id]);

  useEffect(() => {
    if (evaluadosList_id) {
      fetchFilesData(
        setIsLoading,
        setFiles,
        evaluadosList_id,
        35,
        "documentos_evaluado"
      );
      if (fileUploaded) {
        setFileUploaded(false);
      }
    }
  }, [evaluadosList_id, token, fileUploaded]);

  const handleConfirmAction = (action: string, file: any, fileKey: string) => {
    setPendingAction(action);
    setFileToConfirm(file);
    setFileKeyToConfirm(fileKey);

    const module = modules.find((m) => m.fileKey === fileKey);
    setDescriptionToConfirm(
      module ? module.description : "Descripción no disponible."
    );

    setIsModalOpen(true);
  };

  const handleConfirm = (fileKey: string) => {
    if (
      !evaluadosList_id ||
      (!(fileToConfirm instanceof File) && typeof fileToConfirm !== "string")
    ) {
      toast.error(
        !evaluadosList_id
          ? "ID del evaluado no disponible."
          : "Archivo inválido."
      );
      return;
    }

    const module = modules.find((m) => m.fileKey === fileKey);
    if (!module) {
      console.log("Módulo no encontrado para el fileKey:", fileKey);
    }

    pendingAction === "eliminar"
      ? handleFileRemove(fileKey)
      : pendingAction === "subir" && handleUpload(fileKey);

    setIsModalOpen(false);
  };

  const handleCancel = () => setIsModalOpen(false);

  const handleUpload = async (fileKey: string) => {
    const file = files[fileKey];
    if (!(file instanceof File) || !evaluadosList_id) {
      return toast.error("ID del evaluado no disponible o archivo no válido.");
    }

    const match = fileKey.match(/\d+/);
    if (!match) return toast.error("Clave del archivo no válida.");

    const formattedFile = new File(
      [file],
      `${match[0].padStart(2, "0")}_${file.name}`,
      { type: file.type }
    );

    try {
      const { success, message } = await uploadPDF(
        evaluadosList_id,
        "documentos_evaluado",
        formattedFile
      );
      if (success) {
        setSuccessFiles((prev) => ({ ...prev, [fileKey]: true }));
        setFileUploaded(true);
        
        // Guardar en localStorage que el archivo se ha subido correctamente
        if (evaluadosList_id) {
          localStorage.setItem(`documentos_evaluado_${evaluadosList_id}_${fileKey}`, file.name);
        }
      } else {
        throw new Error(message || "Error desconocido.");
      }
    } catch {
      toast.error("Error al subir el archivo.");
      setFiles((prevFiles) => ({
        ...prevFiles,
        [fileKey]: "Sin archivo seleccionado",
      }));
      
      // Actualizar localStorage en caso de error
      if (evaluadosList_id) {
        localStorage.setItem(`documentos_evaluado_${evaluadosList_id}_${fileKey}`, "Sin archivo seleccionado");
      }
    }
  };

  const handleFileRemove = async (fileKey: string) => {
    const file = files[fileKey];
    if (!file || !evaluadosList_id) {
      toast.error(
        file
          ? "ID del evaluado no disponible."
          : "Archivo no válido o no seleccionado."
      );
      return;
    }

    const fileName = file instanceof File ? file.name : file;

    try {
      const { success } = await deletePDF(
        evaluadosList_id,
        "documentos_evaluado",
        fileName
      );
      if (success) {
        setFiles((prev) => ({
          ...prev,
          [fileKey]: "Sin archivo seleccionado",
        }));
        setSuccessFiles((prev) => ({ ...prev, [fileKey]: false }));
        setFileUploaded(false);
        
        // Actualizar localStorage al eliminar un archivo
        if (evaluadosList_id) {
          localStorage.setItem(`documentos_evaluado_${evaluadosList_id}_${fileKey}`, "Sin archivo seleccionado");
        }
      }
    } catch {
      toast.error("Hubo un problema al eliminar el archivo.");
    }
  };

  const procesarArchivo = async (
    fileKey: string,
    action: "view" | "download"
  ): Promise<void> => {
    const file = files[fileKey];
    const fileName = typeof file === "string" ? file : file?.name;

    if (!fileName || !evaluadosList_id) {
      toast.error(
        fileName
          ? "ID del evaluado no disponible."
          : "Archivo no válido o no seleccionado."
      );
      return;
    }

    try {
      await handleFile(
        evaluadosList_id,
        "documentos_evaluado",
        fileName,
        action
      );
    } catch {
      toast.error(
        `Hubo un error al intentar ${
          action === "view" ? "mostrar" : "descargar"
        } el archivo. Por favor, inténtelo de nuevo.`
      );
    }
  };

  const handleFileDrop = (e: DragEvent<HTMLDivElement>, fileKey: string) => {
    e.preventDefault(); // Prevenir el comportamiento predeterminado
    const file = e.dataTransfer.files?.[0]; // Obtener el archivo arrastrado

    if (file) {
      // Si se ha arrastrado un archivo, actualizamos el estado
      setFiles((prevFiles) => {
        const newFiles = {
          ...prevFiles,
          [fileKey]: file, // Actualizar el archivo en el estado
        };
        return newFiles;
      });
    } else {
      // Si no se arrastra ningún archivo, mostrar el texto por defecto
      setFiles((prevFiles) => {
        const newFiles = {
          ...prevFiles,
          [fileKey]: "Sin archivo seleccionado",
        };
        return newFiles;
      });
    }
  };

  const handleOpenFileSelector = (
    fileKey?: string,
    ref?: React.RefObject<HTMLInputElement>
  ) => {
    if (ref?.current) {
      // Usa el ref si está disponible
      ref.current.click();
    } else if (fileKey) {
      // Usa el fileKey para buscar el input por su ID
      const fileInput = document.getElementById(
        `file-input-${fileKey}`
      ) as HTMLInputElement;
      fileInput?.click();
    } else {
      console.error("No se proporcionó ni un ref ni un fileKey válido.");
    }
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fileKey: string
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [fileKey]: file, // Sobrescribe el archivo previo
      }));
    } else {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [fileKey]: "Sin archivo seleccionado", // Si no se selecciona nada, muestra el texto predeterminado
      }));
      
      // Actualizar localStorage
      if (evaluadosList_id) {
        localStorage.setItem(`documentos_evaluado_${evaluadosList_id}_${fileKey}`, "Sin archivo seleccionado");
      }
    }
  };

  const modules = [
    {
      title: "Archivo 1",
      description: files.file1 instanceof File ? files.file1.name : files.file1,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file1",
    },
    {
      title: "Archivo 2",
      description: files.file2 instanceof File ? files.file2.name : files.file2,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file2",
    },
    {
      title: "Archivo 3",
      description: files.file3 instanceof File ? files.file3.name : files.file3,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file3",
    },
    {
      title: "Archivo 4",
      description: files.file4 instanceof File ? files.file4.name : files.file4,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file4",
    },
    {
      title: "Archivo 5",
      description: files.file5 instanceof File ? files.file5.name : files.file5,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file5",
    },
    {
      title: "Archivo 6",
      description: files.file6 instanceof File ? files.file6.name : files.file6,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file6",
    },
    {
      title: "Archivo 7",
      description: files.file7 instanceof File ? files.file7.name : files.file7,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file7",
    },
    {
      title: "Archivo 8",
      description: files.file8 instanceof File ? files.file8.name : files.file8,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file8",
    },
    {
      title: "Archivo 9",
      description: files.file9 instanceof File ? files.file9.name : files.file9,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file9",
    },
    {
      title: "Archivo 10",
      description:
        files.file10 instanceof File ? files.file10.name : files.file10,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file10",
    },
    {
      title: "Archivo 11",
      description:
        files.file11 instanceof File ? files.file11.name : files.file11,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file11",
    },
    {
      title: "Archivo 12",
      description:
        files.file12 instanceof File ? files.file12.name : files.file12,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file12",
    },
    {
      title: "Archivo 13",
      description:
        files.file13 instanceof File ? files.file13.name : files.file13,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file13",
    },
    {
      title: "Archivo 14",
      description:
        files.file14 instanceof File ? files.file14.name : files.file14,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file14",
    },
    {
      title: "Archivo 15",
      description:
        files.file15 instanceof File ? files.file15.name : files.file15,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file15",
    },
    {
      title: "Archivo 16",
      description:
        files.file16 instanceof File ? files.file16.name : files.file16,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file16",
    },
    {
      title: "Archivo 17",
      description:
        files.file17 instanceof File ? files.file17.name : files.file17,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file17",
    },
    {
      title: "Archivo 18",
      description:
        files.file18 instanceof File ? files.file18.name : files.file18,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file18",
    },
    {
      title: "Archivo 19",
      description:
        files.file19 instanceof File ? files.file19.name : files.file19,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file19",
    },
    {
      title: "Archivo 20",
      description:
        files.file20 instanceof File ? files.file20.name : files.file20,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file20",
    },
    {
      title: "Archivo 21",
      description:
        files.file21 instanceof File ? files.file21.name : files.file21,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file21",
    },
    {
      title: "Archivo 22",
      description:
        files.file22 instanceof File ? files.file22.name : files.file22,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file22",
    },
    {
      title: "Archivo 23",
      description:
        files.file23 instanceof File ? files.file23.name : files.file23,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file23",
    },
    {
      title: "Archivo 24",
      description:
        files.file24 instanceof File ? files.file24.name : files.file24,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file24",
    },
    {
      title: "Archivo 25",
      description:
        files.file25 instanceof File ? files.file25.name : files.file25,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file25",
    },
    {
      title: "Archivo 26",
      description:
        files.file26 instanceof File ? files.file26.name : files.file26,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file26",
    },
    {
      title: "Archivo 27",
      description:
        files.file27 instanceof File ? files.file27.name : files.file27,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file27",
    },
    {
      title: "Archivo 28",
      description:
        files.file28 instanceof File ? files.file28.name : files.file28,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file28",
    },
    {
      title: "Archivo 29",
      description:
        files.file29 instanceof File ? files.file29.name : files.file29,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file29",
    },
    {
      title: "Archivo 30",
      description:
        files.file30 instanceof File ? files.file30.name : files.file30,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file30",
    },
    {
      title: "Archivo 31",
      description:
        files.file31 instanceof File ? files.file31.name : files.file31,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file31",
    },
    {
      title: "Archivo 32",
      description:
        files.file32 instanceof File ? files.file32.name : files.file32,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file32",
    },
    {
      title: "Archivo 33",
      description:
        files.file33 instanceof File ? files.file33.name : files.file33,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file33",
    },
    {
      title: "Archivo 34",
      description:
        files.file34 instanceof File ? files.file34.name : files.file34,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file34",
    },
    {
      title: "Archivo 35",
      description:
        files.file35 instanceof File ? files.file35.name : files.file35,
      icon: <FileCheck className="h-8 w-8" />,
      buttons: {
        create: { show: true },
      },
      fileKey: "file35",
    },
    {
      title: "Descargar formulario",
      description: "Archivo completo",
      icon: <Download className="h-8 w-8" />,
      buttons: {
        des: { show: true },
      },
      fileKey: "file36",
    },
  ];

  const allModulesAreGreen = modules.every((mod) => {
    return (
      mod.fileKey === "file36" || // Ignorar el módulo "Descargar formulario"
      (files[mod.fileKey] !== "Sin archivo seleccionado" &&
      !(files[mod.fileKey] instanceof File))
    );
  });

  return (
    <>
      <EvaluadoInfo />
      <div className="flex justify-between items-center px-8 py-4">
        <button
          onClick={() => {
            window.scrollTo(0, 0);
            navigate(`/modulos_presenciales/${queryEvaluado.data?.uuid}`);
          }}
          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 transition"
        >
          Regresar
        </button>
      </div>

      <div className="container mx-auto">
        <h1 className="font-bold">Documentos (Presencial)</h1>
        <div>
          {isLoading ? (
            <div className="flex justify-center items-center py-4">
              <div
                className="spinner-border animate-spin inline-block w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full"
                role="status"
              >
                <span className="sr-only">Cargando...</span>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-4">
              {modules.map((module, index) => {
                // Si todos los módulos están en verde, mostramos el módulo "Descargar formulario"
                if (
                  module.title === "Descargar formulario" &&
                  !allModulesAreGreen
                ) {
                  return null; // No renderizamos este módulo si no todos están en verde
                }

                // Si todos los módulos están en verde, muestra el botón para "Descargar formulario"
                if (
                  allModulesAreGreen &&
                  module.title === "Descargar formulario"
                ) {
                  return (
                    <div
                      key={index}
                      className="border-3 rounded-lg p-4 shadow flex flex-col justify-between max-w-md w-full border-green-500"
                    >
                      <div className="mb-2 flex items-center gap-4">
                        {module.icon}
                        <h3 className="text-lg font-semibold mb-0">
                          {module.title}
                        </h3>
                      </div>
                      <p className="mb-2 text-gray-700">{module.description}</p>
                      <div className="flex justify-center space-x-4 mt-4">
                        <button
                          title="Descargar archivo"
                          onClick={() =>
                            handleMergePdfs(
                              evaluadosList_id ?? "defaultId", // Usar un valor predeterminado si es undefined
                              "documentos_evaluado", // Este valor debe venir de tus datos o props
                              `Modulo_documentos_evaluado_${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}.pdf`, // Este valor debe venir de tus datos o props
                              "download" // Acción "download" para descargar el archivo
                            )
                          }
                          className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 transition flex justify-center items-center"
                        >
                          <Download className="w-5 h-5" />
                        </button>
                        <button
                          title="Ver archivo"
                          onClick={() =>
                            handleMergePdfs(
                              evaluadosList_id ?? "defaultId", // Usar un valor predeterminado si es undefined
                              "documentos_evaluado", // Este valor debe venir de tus datos o props
                              `Modulo_documentos_evaluado_${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}.pdf`, // Este valor debe venir de tus datos o props
                              "view" // Acción "download" para descargar el archivo
                            )
                          }
                          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition flex justify-center items-center"
                        >
                          <Eye className="w-5 h-5" />
                        </button>
                      </div>
                    </div>
                  );
                }

                return (
                  <div
                    key={index}
                    className={`border-3 rounded-lg p-4 shadow flex flex-col justify-between max-w-md w-full ${
                      files[module.fileKey] === "Sin archivo seleccionado"
                        ? "border-red-500"
                        : files[module.fileKey] instanceof File
                        ? "border-yellow-300"
                        : "border-green-500"
                    }`}
                  >
                    <div className="flex flex-col items-left">
                      <div className="mb-4 flex items-center gap-2">
                        {module.icon}
                        <h3 className="text-base font-semibold mb-0 text-left">
                          {module.title}
                        </h3>
                      </div>
                    </div>

                    <p
                      className="mb-2 text-gray-700 break-words max-w-full"
                      style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                      title={module.description}
                    >
                      {module.description}
                    </p>

                    {/* Solo renderizamos el área de arrastre si no hay archivo cargado */}
                    {files[module.fileKey] === "Sin archivo seleccionado" && (
                      <FileDropZone
                        module={module} // Pasar el objeto completo 'module', no solo 'module.fileKey'
                        handleFileDrop={handleFileDrop} // Asegúrate de pasar solo las funciones, no ejecutarlas
                        handleFileChange={handleFileChange} // Lo mismo aquí
                      />
                    )}

                    {/* Si el archivo está cargado (no "Sin archivo seleccionado") */}
                    {files[module.fileKey] !== "Sin archivo seleccionado" && (
                      <div className="flex justify-center space-x-4 mt-4">
                        {/* Botón de "Subir archivo" */}
                        {files[module.fileKey] &&
                          files[module.fileKey] instanceof File &&
                          module.buttons.create?.show && (
                            <button
                              title="Subir archivo"
                              onClick={() =>
                                handleConfirmAction(
                                  "subir",
                                  files[module.fileKey],
                                  module.fileKey
                                )
                              }
                              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 flex justify-center items-center"
                            >
                              <Upload className="w-5 h-5" />
                            </button>
                          )}
                        {/* Botón de "Eliminar archivo" */}
                        {files[module.fileKey] &&
                          files[module.fileKey] !==
                            "Sin archivo seleccionado" &&
                          !(files[module.fileKey] instanceof File) && (
                            <button
                              title="Eliminar archivo"
                              onClick={() =>
                                handleConfirmAction(
                                  "eliminar",
                                  files[module.fileKey],
                                  module.fileKey
                                )
                              }
                              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 transition flex justify-center items-center"
                            >
                              <Trash2 className="w-5 h-5" />
                            </button>
                          )}

                        {/* Botón de "Ver archivo" */}
                        {files[module.fileKey] &&
                          files[module.fileKey] !==
                            "Sin archivo seleccionado" &&
                          !(files[module.fileKey] instanceof File) && (
                            <button
                              title="Ver archivo"
                              onClick={() =>
                                procesarArchivo(module.fileKey, "view")
                              }
                              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition flex justify-center items-center"
                            >
                              <Eye className="w-5 h-5" />
                            </button>
                          )}

                        {/* Botón de "Descargar archivo" */}
                        {files[module.fileKey] &&
                          files[module.fileKey] !==
                            "Sin archivo seleccionado" &&
                          !(files[module.fileKey] instanceof File) && (
                            <button
                              title="Descargar archivo"
                              onClick={() =>
                                procesarArchivo(module.fileKey, "download")
                              }
                              className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 transition flex justify-center items-center"
                            >
                              <Download className="w-5 h-5" />
                            </button>
                          )}

                        {/* Botón "Cambiar archivo" */}
                        {files[module.fileKey] instanceof File && (
                          <>
                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={(e) =>
                                handleFileChange(e, module.fileKey)
                              }
                              className="hidden"
                            />
                            <button
                              title="Cambiar archivo"
                              onClick={() =>
                                handleOpenFileSelector(undefined, fileInputRef)
                              }
                              className="bg-indigo-500 text-white py-2 px-4 rounded hover:bg-indigo-600 transition flex justify-center items-center"
                            >
                              <RefreshCcw className="w-5 h-5" />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <ConfirmarModal
        isOpen={isModalOpen}
        action={pendingAction}
        description={descriptionToConfirm}
        onConfirm={() => handleConfirm(fileKeyToConfirm)}
        onCancel={handleCancel}
      />
    </>
  );
};